 import { Component, EventEmitter, Input, Output} from "@angular/core";
 import { CommonModule } from "@angular/common";
 import { FormsModule, ReactiveFormsModule } from "@angular/forms";
 import { TranslateModule } from "@ngx-translate/core";
import { UserRequestBase, Userrequestdto} from "../../../../_models/user/userrequestdto";
import { AuthenticationService } from "../../../../_services";
import { Router } from "@angular/router";
import { ModalComponent } from "../../../../shared/design-system/modal/modal.component";
import { ButtonComponent } from "../../../../shared/design-system/button/button.component";
import { InfoTextComponent } from "../../../../shared/design-system/info-text/info-text.component";
import { ICONS } from "../../../../_helpers/icons.constants";
import { TranslateService } from "@ngx-translate/core";
import { ButtonConfig } from "../../../../shared/design-system/button/button.modal";
import { InfoTextConfig } from "../../../../shared/design-system/info-text/info-text.modal";
import { ModalConfig } from "../../../../shared/design-system/modal/modal.modal";

@Component({
    selector: "app-existing-domain",
    templateUrl: "./existing-domain.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, ModalComponent, ButtonComponent, InfoTextComponent]
})
export class ExistingDomainComponent {
    @Input() firstname: string = "";
    @Input() lastname: string = "";
    @Input() email: string = "";
    @Input() domainName: string = "";
    @Input() userrequest: UserRequestBase;
    @Output() loginRedirect = new EventEmitter<void>();
    public ICONS = ICONS;
    continueConfig!: ButtonConfig;
    invitationInfoConfig!: InfoTextConfig;
    loginInfoConfig!: InfoTextConfig;
    modalConfig!: ModalConfig;
 
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router, private translate: TranslateService) 
    {
        this.userrequest = new UserRequestBase();
    }

    ngOnInit() {
        this.continueConfig = {
            id: 'continue-button',
            label: this.translate.instant('continue'),
            color: "primary", 
            size: "md",
            block: true,
            ariaLabel: this.translate.instant("continue")
        };
        this.invitationInfoConfig = {
            iconSrc: ICONS.MAIL,
        };
        this.loginInfoConfig = {
            iconSrc: ICONS.LOG_IN,
        };
        this.modalConfig = {
            visible: false,
            title: this.translate.instant('domain_registered'),
            variant: "error",
            headerIconSrc: ICONS.ALERT_TRIANGLE,
            headerIconAltOverride: "Completed"
        };
    }

    showModal() {
        this.modalConfig = { ...this.modalConfig, visible: true };
    }

    SendInviteeNotificationToFinanceManager(){

        this.userrequest.RequestInfo = new Userrequestdto();
        this.userrequest.WebApiName = "SoloRegister";
        this.userrequest.WebApiVersion = 1;
        this.userrequest.RequestId = "111";
        this.userrequest.RequestInfo.FirstName =
        this.firstname;
        this.userrequest.RequestInfo.LastName = this.lastname;
        this.userrequest.RequestInfo.LoginId = this.email;


        this.authenticationService.SendInviteeNotificationToFinanceManager(this.userrequest).subscribe(
        (domainData:any) => {});

        this.router.navigate(["login"]);

    }

    onLoginClick() {
        this.loginRedirect.emit();
    }
      // Modal UI state used by template
    showSuccess: boolean = false;

    // Called by the modal OK button (footer)
    handleSave() {
        // default behavior: close the modal and emit a confirm handler
        this.showSuccess = false;
        this.modalConfig = { ...this.modalConfig, visible: false };
        this.onSuccessConfirm({ saved: true });
    }

    // Receives confirmed payload from ds-modal
    onSuccessConfirm(payload: any) {
    // Implement any success handling logic here (e.g. show toast, navigate)
    console.log('Invite success confirmed:', payload);
    }
}